import {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react'

const DisclosureForElectronicConsent = forwardRef(({ data, refToPrint }, ref) => {

    const [agreeEsign, setAgreeEsign] = useState(data?.agreeEsign ?? false)
    const [error, setError] = useState('')

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            let isValid = true

            if (!agreeEsign) {
                setError('You need to agree to conduct the identity verification process electronically')
                isValid = false
            }

            if (isValid) {
                setError('')
            }

            return {
                isValid,
                value: {
                    agreeEsign,
                },
            }
        },
    }))

    return (
        <div ref={refToPrint} className="flex items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-gray-800">
                        Electronic Document and Signature Agreement
                    </h1>
                    <p className="text-gray-700 text-base">
                        This page outlines your agreement to conduct the identity validation and
                        pre-employment screening process electronically with <span className="font-semibold">VerifiedID LLC and
                            its authorized agents</span>, pursuant to the <em>Electronic Signatures in Global
                                and National Commerce Act (ESIGN Act)</em> and the <em>Uniform Electronic
                                    Transaction Act (UETA)</em>.
                    </p>
                </div>

                <div className="bg-gray-100 p-4 rounded-lg space-y-3 text-gray-700 text-sm">
                    <p>By proceeding, you agree to:</p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>
                            Receive and sign all identity verification and screening documents
                            electronically. Your electronic signature will be legally binding.
                        </li>
                        <li>
                            Have the necessary technology (internet access, browser) to view and
                            sign these documents.
                        </li>
                        <li>
                            Understand that you can request paper copies or withdraw your consent
                            to electronic processing by contacting VerifiedID LLC at{' '}
                            <a href="tel:+18887182597" className="text-blue-600 underline">(888) 718-2597</a>{' '}
                            or via email at{' '}
                            <a href="mailto:support@verifiedid.co" className="text-blue-600 underline">support@verifiedid.co</a>.
                        </li>
                    </ul>
                </div>

                <div className="space-y-2">
                    <h2 className="text-lg font-semibold text-gray-800">Consent to Electronic Records</h2>
                    <p className="text-gray-700 text-sm">
                        Do you agree to conduct the identity verification process electronically through VerifiedID?
                    </p>

                    <label className="flex items-start space-x-2 cursor-pointer pt-2">
                        <input
                            type="checkbox"
                            checked={agreeEsign}
                            onChange={(e) => setAgreeEsign(e.target.checked)}
                            className="mt-1"
                        />
                        <span className="text-gray-700 text-sm">
                            I AGREE to conduct the identity verification process electronically.
                        </span>
                    </label>
                </div>

                {error && (
                    <p className="mt-1 text-sm text-red-600">{error}</p>
                )}
            </div>
        </div>
    )
})

export default DisclosureForElectronicConsent
